import { render } from "./ValidateAppointment.vue?vue&type=template&id=4720374d"
import script from "./ValidateAppointment.vue?vue&type=script&lang=js"
export * from "./ValidateAppointment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__